import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PickupInformation } from 'src/app/model/deliveryChoiceModels/pickupInformation.model';
import { RefDeliveryinformation } from 'src/app/model/refDeliveryinformation.model';
import { AtInternetService } from 'src/app/services/at-internet.service';

@Component({
  selector: 'app-pickup-point',
  templateUrl: './pickup-point.component.html',
  styleUrls: ['./pickup-point.component.scss']
})
export class PickupPointComponent implements OnInit {

  @Input() deliveryPoint: PickupInformation;
  @Input() index: string;
  @Input() refDeliveryinformation: RefDeliveryinformation;
  @Input() chosenDeliveryPoint;
  @Input() data;
  isMobileScreen: boolean = false;
  isCollapsed: boolean = true;
  @Output() validatePickup = new EventEmitter<PickupInformation>();
  @Output() selectPickup = new EventEmitter<string>();
  typePoint;
  labelButtonPickme: String = "En savoir plus sur Pickme";

  constructor(private atInternetService: AtInternetService) { }

  ngOnInit(): void {
    this.isMobile();
    this.switchTypePoint(this.deliveryPoint.typePoint);
  }

  isMobile() {
    var width = window.outerWidth;
    if (width < 600) {
      this.isMobileScreen = true;
    }
  }
  choosePickup(pickup) {
    this.validatePickup.emit(pickup);
  }
  toggleOpeningHours() {
    this.isCollapsed = !this.isCollapsed;
  }

  switchTypePoint(typePoint) {
    switch (typePoint) {
      case "BPR": {
        this.typePoint = "Bureau de Poste";
        return this.typePoint;
      }
      case "A2P": {
        this.typePoint = "Relais Commerçant";
        return this.typePoint;
      }
      case "CIT": {
        this.typePoint = "Consigne";
        return this.typePoint;
      }
      case "PKM": {
        this.typePoint = "Voisin-relais";
        return this.typePoint;
      }
      default: {
        break;
      }
    }
  }

  redirect(url) {
    this.atInternetService.generateClickAction(
      this.data.tag,
      'cta_Reprogrammation_HD_En_savoir_plus_sur_pickme',
      'Reprogrammation_HD'
    );
    window.open(url, "_blank");
  }

}
